import { typedApi } from "@/api/typed-client";
import { useMutation, useQueryClient } from "@tanstack/react-query";
import { toast } from "sonner";

type Action = "activate" | "archive" | "discard";

const ACTION_PATH = {
  activate: "/v1/models/{model_id}/revisions/{rev_no}/activate",
  archive: "/v1/models/{model_id}/revisions/{rev_no}/archive",
  discard: "/v1/models/{model_id}/revisions/{rev_no}/discard",
} as const;

export function useRevisionAction(modelId: string, action: Action) {
  const qc = useQueryClient();
  return useMutation({
    mutationFn: async (revNo: number) => {
      const { data, error } = await typedApi.POST(ACTION_PATH[action], {
        params: { path: { model_id: modelId, rev_no: revNo } },
      });
      if (error) throw new Error(JSON.stringify(error));
      return data;
    },
    onSuccess: (_d, revNo) => {
      qc.invalidateQueries({ queryKey: ["models", modelId] });
      qc.invalidateQueries({ queryKey: ["models", modelId, "revisions"] });
      qc.invalidateQueries({ queryKey: ["models"] });
      toast.success(`Revision #${revNo} ${action}d`);
    },
    onError: (e) => toast.error(`${action} failed: ${(e as Error).message}`),
  });
}
